import { useLayoutEffect } from "react";

/**
 * A React hook that prevents body scrolling while a component is mounted.
 * Useful for modals, overlays, and other components that should prevent background scrolling.
 */
export function useLockBodyScroll(isActive: boolean = true) {
  useLayoutEffect(() => {
    if (!isActive) return;

    // Get original body overflow
    const originalStyle = window.getComputedStyle(document.body).overflow;
    // Prevent scrolling on mount
    document.body.style.overflow = "hidden";
    // Re-enable scrolling when component unmounts
    return () => {
      document.body.style.overflow = originalStyle;
    };
  }, [isActive]); // Empty array ensures effect is only run on mount and unmount
}
